module.exports = __webpack_public_path__ + "static/img/bdhwlw.f0a7b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdhwlw.png
// module id = ml1/
// module chunks = 0